export const ACTIVITY_THROTTLE = 3000;
